import { VIEW_ASSIGN_PROJECT_INFO } from "../actions/assignRecruiterAction";

const initialState = {
  projectInfo: {},
};

const assignRecruiterReducer = (state = initialState, action) => {
  if (action.type === VIEW_ASSIGN_PROJECT_INFO) {
    return {
      ...state,
      projectInfo: action.payload,
    };
  }

  return state;
};
export default assignRecruiterReducer;
